import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import Typography from '@mui/material/Typography';
import useEvaluatePreoffers from '../../hooks/useEvaluatePreoffers';

const ChileActionButton = ({
  finalAction,
  onCreditLineError,
}) => {
  const finishMutation = useCallback((warningCode) => {
    finalAction(warningCode);
  }, [finalAction]);

  const { requestPreoffer, loading } = useEvaluatePreoffers(finishMutation, onCreditLineError);

  return (
    <LoadingButton
      id="cart-preoffer-evaluate"
      variant="contained"
      color="primary"
      sx={{
        width: '100%',
      }}
      loading={loading}
      onClick={requestPreoffer}
    >
      <Typography variant="small_3" color="white" fontWeight={700}>
        Evaluar
      </Typography>
    </LoadingButton>
  );
};

ChileActionButton.propTypes = {
  finalAction: PropTypes.func.isRequired,
  onCreditLineError: PropTypes.func,
};

ChileActionButton.defaultProps = {
  onCreditLineError: () => null,
};

export default ChileActionButton;
